<div style="display: flex; justify-content: space-between; align-items: center">
  <button
    mat-button
    color="primary"
    style="margin-top: 1rem; margin-left: 1rem"
    (click)="onClickSignOut()"
  >
    <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
    Se déconnecter
  </button>

  <img
    style="width: 100px; height: 100%"
    src="../../../assets/img/logo.png"
    alt=""
  />

  <div style="display: flex; align-items: center">
    <mat-icon fontSet="material-symbols-outlined">account_circle</mat-icon>
    <span style="margin-right: 1rem; margin-left: 0.5rem">{{ userEmail }}</span>
  </div>
</div>
<div style="display: flex; flex-direction: column; align-items: center">
  <h1>Enregistrer un modèle</h1>
  <form
    style="
      display: flex;
      gap: 1rem;
      flex-direction: column;
      align-items: start;
      width: 600px;
      margin: 1rem;
    "
    [formGroup]="form"
  >
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Nom du modèle</mat-label>
      <input
        matInput
        placeholder="Example : OBIM ISEP 2024"
        formControlName="modelName"
      />
      <mat-error *ngIf="form.get('modelName')?.hasError('required')">
        Le nom du modèle est requis
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Version du modèle</mat-label>
      <input
        matInput
        placeholder="Example : OBIM ISEP 2024"
        formControlName="modelVersion"
      />
      <mat-error *ngIf="form.get('modelVersion')?.hasError('required')">
        Le nom du modèle est requis
      </mat-error>
    </mat-form-field>

    <!-- Hidden file input -->
    <input
      #fileInput
      type="file"
      accept=".xlsx, .xls, .xlsm"
      style="display: none"
      (change)="onFileSelected($event)"
    />

    <!-- Upload Button -->
    <button mat-button (click)="fileInput.click()">
      <mat-icon fontSet="material-symbols-outlined">cloud_upload</mat-icon>
      Téléverser un fichier Excel
    </button>

    @if (form.get("file")!.value) {
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="hint hint__secondary">
          <mat-icon fontSet="material-symbols-outlined">description</mat-icon
          >{{ form.get("file")!.value.name }}
        </div>
        <hr />

        @if (!form.get("file")!.valid) {
        <div class="hint">
          <mat-icon fontSet="material-symbols-outlined">error</mat-icon>
          Le fichier inséré n'est pas un fichier Excel (.xls, .xlsx, .xlsm).
          Veuillez réessayer avec un autre fichier
        </div>
        } @if (fileError) {
        <div class="hint">
          <mat-icon fontSet="material-symbols-outlined">error</mat-icon>
          <div>
            <span>
              Le fichier Excel inséré ne respecte pas le format standard :
            </span>
            <br />
            <b>{{ fileError }}</b>
          </div>
        </div>
        } @else {
        <div class="hint hint__valid">
          <mat-icon fontSet="material-symbols-outlined">check</mat-icon>
          Vérifications OK
        </div>
        }
      </mat-card-content>
    </mat-card>
    }

    <p>
      Le fichier doit suivre le standard à jour.
      <br />
      Pour avoir la dernière version du standard, merci de contacter
      l'administrateur technique de l'application
      (nicolas.filizzola&commat;rweality.com)
    </p>

    <div style="display: flex; align-items: center">
      <button
        mat-button
        [disabled]="form.invalid || fileError.length > 0"
        (click)="onSubmit()"
      >
        <mat-icon
          fontSet="material-symbols-outlined"
          fontIcon="save"
        ></mat-icon>
        Enregistrer le modèle
      </button>
      <mat-spinner
        [diameter]="25"
        *ngIf="loadingSpinnerActiveState.registration"
      ></mat-spinner>
    </div>

    @if(fileRegistrationCompleted) {
    <span class="upload-result">
      <mat-icon fontSet="material-symbols-outlined">check</mat-icon> Le modèle a
      été enregistré avec succès !
    </span>
    <span
      class="upload-result"
      style="display: flex; align-items: center; gap: 0.5rem"
    >
      Code d'identification du modèle :
      <b #registeredFileIdRef>{{ registeredFileId }}</b>
      <button
        mat-icon-button
        (click)="onClickCopyToClipboard(registeredFileIdRef.textContent)"
      >
        <mat-icon fontSet="material-symbols-outlined">content_copy</mat-icon>
      </button>
    </span>
    }
  </form>

  <div style="width: 800px">
    @if (loadingSpinnerActiveState.loadingFiles) {
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
    >
      <h1>Chargement des modèles enregistrés...</h1>
      <mat-spinner></mat-spinner>
    </div>
    } @else {
    <h1 style="text-align: center">
      {{
        (registeredModels$ | async)!.length > 0
          ? "Modèles enregistrés"
          : "Aucun modèle enregistré"
      }}
    </h1>

    @for (model of (registeredModels$ | async); track $index) {
    <mat-card appearance="outlined" style="height: 100%; margin-bottom: 0.5rem">
      <mat-card-header>
        <mat-card-title>{{ model.modelName }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Version: {{ model.modelVersion }}</p>
        <p>
          Enregistré le
          {{ model.uploadedAt._seconds * 1000 | date : "dd/MM/yyyy, HH:mm:ss" }}
        </p>
        <p>
          Code d'identification : <b>{{ model.id }}</b>
        </p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button (click)="onClickOpenModel(model.id)">
          <mat-icon fontSet="material-symbols-outlined">open_in_new</mat-icon>
          Visualiser le modèle
        </button>
        <button mat-button (click)="onClickDelete(model.id)">
          <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
          Supprimer le modèle
        </button>
        @if (loadingSpinnerActiveState.delete.get(model.id)){
        <mat-spinner [diameter]="25"></mat-spinner>
        }
        <button mat-button (click)="onClickUpdateModel(model)">
          <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
          Mettre à jour le modèle
        </button>
      </mat-card-actions>
    </mat-card>
    } }
  </div>
</div>
